import type { AppLocale } from '@/constants/appLocale'


const COUPON_DETAIL_ZH_IMAGE_FILE_1 = 'd60848e8bff2b1cfe9b1922612285c73.png'
const COUPON_DETAIL_EN_IMAGE_FILE_1 = 'c19ed6ba0789caf218f9e12d4bf85d9f.png'

const COUPON_DETAIL_ZH_IMAGE_FILE_3 = '264a4388fb28fb0ed2fc6e0b3ec0b68c.png'
const COUPON_DETAIL_EN_IMAGE_FILE_3 = 'e4eaf2fb786e445ad5d916b54b2396bb.png'

const COUPON_IMAGW_FILE_25 = '3554a32156303b045179f18cbecb68fe.png'
const DEFAULT_COUPON_LIST_IMAGE_FILE = 'e35a517a364f4fde4377acb6ee2fd59b.png'
const COUPON_IMAGE_FILE_6 = 'f52803638ecc113658027d66de1ee6aa.png'
const COUPON_IMAGE_FILE_10 = 'b917bb09620feac6731fb34a053b53be.png'
const COUPON_IMAGE_FILE_OVER = '5b90ccf3998777f82b9dbad6525803dd.png'

export type CouponLocaleText = Record<AppLocale, string>

const localeText = (
  zhCN: string,
  zhTW: string,
  enUS: string,
  jaJP: string,
  koKR: string,
): CouponLocaleText => ({
  zh_CN: zhCN,
  zh_TW: zhTW,
  en_US: enUS,
  ja_JP: jaJP,
  ko_KR: koKR,
})

export const COUPON_STATIC_TEXT = {
  touristExclusiveSuffix: localeText(
    '游客专属优惠券',
    '遊客專屬優惠券',
    ' Tourist Exclusive Coupon',
    '観光客専用クーポン',
    ' 관광객 전용 쿠폰',
  ),
  claimToday: localeText(
    '现在领取，当日使用',
    '現在領取，當日使用',
    'Claim now, use today',
    '今すぐ受け取り、当日利用',
    '지금 받고 당일 사용',
  ),
  participantsSuffix: localeText(
    '人参加过',
    '人參加過',
    'people joined',
    '人が参加済み',
    '명 참여',
  ),
} as const

export const COUPON_CATEGORY = {
  shopping: localeText('购物', '購物', 'Shopping', 'ショッピング', '쇼핑'),
  fashion: localeText('时尚服装', '時尚服裝', 'Fashion', 'ファッション', '패션'),
  beauty: localeText('美容护肤', '美容護膚', 'Beauty', '美容', '뷰티'),
  dutyFree: localeText('免税店', '免稅店', 'Duty-free', '免税店', '면세점'),
  jewelry: localeText('珠宝腕表', '珠寶腕錶', 'Jewelry & Watches', 'ジュエリー・時計', '주얼리/시계'),
  departmentStore: localeText('高端百货', '高端百貨', 'Department Store', '百貨店', '백화점'),
  optical: localeText('眼镜店', '眼鏡店', 'Optical', '眼鏡店', '안경점'),
  vintage: localeText('二手店', '二手店', 'Vintage', '中古店', '빈티지'),
  outdoor: localeText('运动户外', '運動戶外', 'Outdoor', 'アウトドア', '아웃도어'),
  other: localeText('其他', '其他', 'Other', 'その他', '기타'),
  electronics: localeText('数码家电', '數碼家電', 'Electronics', '家電', '디지털/가전'),
  homeGoods: localeText('家居用品', '家居用品', 'Home Goods', '生活雑貨', '생활용품'),
  drugstore: localeText('药妆店', '藥妝店', 'Drugstore', 'ドラッグストア', '드럭스토어'),
} as const

// 

export type TempCouponStore = {
  id: string
  merchantName: string
  discount?: CouponLocaleText
  primaryCategory: CouponLocaleText
  secondaryCategory: CouponLocaleText
  rating: string
  reviewCount: number
  participantCount: string
  /** 列表卡片图片 */
  listImageFile: string
  /** 详情页中文图片 */
  detailImageZhFile: string
  /** 详情页英文图片，非中文语言都使用这个字段 */
  detailImageEnFile: string
}

const withStoreIds = (stores: Array<Omit<TempCouponStore, 'id'>>): TempCouponStore[] =>
  stores.map((store, index) => ({
    id: `store-${index + 1}`,
    ...store,
  }))

export const TEMP_COUPON_STORES: TempCouponStore[] = withStoreIds([
  {
    merchantName: 'SNIDEL',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.8',
    reviewCount: 21,
    participantCount: '300+',
    listImageFile: '5dab7e42c569baf9304d521dc414f2ed.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'SNIDEL HOME',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.6',
    reviewCount: 32,
    participantCount: '200+',
    listImageFile: '5cc9dd2a5e7d8fa0b57093e10c0c1656.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'gelato pique',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.9',
    reviewCount: 65,
    participantCount: '500+',
    listImageFile: '9e64d080087d25ebfac381ca51e1b685.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'LILY BROWN',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.6',
    reviewCount: 84,
    participantCount: '300+',
    listImageFile: '7e9b084dc49cfa6afe370f0b8e3eb830.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'FRAY I.D',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.4',
    reviewCount: 28,
    participantCount: '200+',
    listImageFile: 'f43fb98fd4d583e443bc6ff1ad55d666.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'Mila Owen',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.7',
    reviewCount: 56,
    participantCount: '400+',
    listImageFile: '324ec7da6d41469d92a7ff29121a8173.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'FURFUR',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.6',
    reviewCount: 55,
    participantCount: '300+',
    listImageFile: '7b2997150b7f443ebeb5fae4168c44a8.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'styling',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.5',
    reviewCount: 121,
    participantCount: '600+',
    listImageFile: 'ddafef2f4fcb024be16f3ef26f31b13d.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'CELFORD',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.8',
    reviewCount: 89,
    participantCount: '500+',
    listImageFile: '6353dcafe8edcca82d31258955e80492.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'USAGI ONLINE STORE',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.5',
    reviewCount: 48,
    participantCount: '100+',
    listImageFile: '23dc72d80170eb426731de12ec553a47.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'emmi',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.9',
    reviewCount: 110,
    participantCount: '600+',
    listImageFile: 'ba69c480520d84c3d1c75520dd3702f0.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'MIESROHE',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.5',
    reviewCount: 31,
    participantCount: '300+',
    listImageFile: 'c3cad77a36b3464ed933cffa4ab11352.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'MUCHA',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.9',
    reviewCount: 128,
    participantCount: '400+',
    listImageFile: '185bf6c3639ef8d519a6b7050f1987e9.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'gelato pique homme',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.4',
    reviewCount: 31,
    participantCount: '100+',
    listImageFile: '4abe2cab3ad898ee0f49ccdc28fafad0.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'JAMIE KAY',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.6',
    reviewCount: 66,
    participantCount: '200+',
    listImageFile: COUPON_IMAGE_FILE_6,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'SOFTHYPHEN',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.8',
    reviewCount: 36,
    participantCount: '200+',
    listImageFile: '4d378f0e6f3687a7ec1c25bdeba641a7.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'CosmeKitchen',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.beauty,
    rating: '4.9',
    reviewCount: 36,
    participantCount: '400+',
    listImageFile: '0f2abd6b6ba2b09a950ab5d2b7caca4f.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'Biople',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.beauty,
    rating: '4.6',
    reviewCount: 45,
    participantCount: '300+',
    listImageFile: '37b0b4f4474383384c742a2bac80eeee.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'SNIDEL Beauty',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.beauty,
    rating: '4.8',
    reviewCount: 24,
    participantCount: '200+',
    listImageFile: '4e059b7c2e937feb2456e465280590b4.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'Celvoke',
    discount: localeText(
      '94折+免税劵',
      '94折+免稅劵',
      '6% Off + Tax-free',
      '6% Off + 免税劵',
      '6% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.beauty,
    rating: '4.9',
    reviewCount: 106,
    participantCount: '500+',
    listImageFile: '27d1c9a4ac8d30dc2671c9ca04d15607.png',
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_1,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_1,
  },
  {
    merchantName: 'Anna Sui mini',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.5',
    reviewCount: 51,
    participantCount: '400+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'Flower Kids Factory',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.6',
    reviewCount: 42,
    participantCount: '200+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'kate spade',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.7',
    reviewCount: 61,
    participantCount: '400+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'Lovetoxic',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.6',
    reviewCount: 47,
    participantCount: '100+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'mezzo piano',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.9',
    reviewCount: 36,
    participantCount: '300+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'petit main',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.5',
    reviewCount: 28,
    participantCount: '200+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'minimal',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.5',
    reviewCount: 31,
    participantCount: '200+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'niko and...',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.8',
    reviewCount: 52,
    participantCount: '300+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'RAGE BLUE',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.4',
    reviewCount: 33,
    participantCount: '100+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'HARE',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.7',
    reviewCount: 41,
    participantCount: '200+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: COUPON_DETAIL_ZH_IMAGE_FILE_3,
    detailImageEnFile: COUPON_DETAIL_EN_IMAGE_FILE_3,
  },
  {
    merchantName: 'Japan Duty Free GINZA',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.dutyFree,
    rating: '4.5',
    reviewCount: 52,
    participantCount: '400+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '99268de052065985a6cf45616d83c8de.png',
    detailImageEnFile: 'e69d25753dc23868eeb9b7ae4c5117d1.png',
  },
  {
    merchantName: '萧邦Chopard',
    discount: localeText(
      '2.5% Off + 免税劵',
      '2.5% Off + 免稅劵',
      '2.5% Off + Tax-free',
      '2.5% Off + 免税劵',
      '2.5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.jewelry,
    rating: '4.7',
    reviewCount: 34,
    participantCount: '200+',
    listImageFile: COUPON_IMAGW_FILE_25,
    detailImageZhFile: '69d735caf3449fc22b95bf46029197b6.png',
    detailImageEnFile: 'b3b3693d3661970120ae4a6a8a2a636c.png',
  },
  {
    merchantName: 'Fukuya',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.departmentStore,
    rating: '4.5',
    reviewCount: 19,
    participantCount: '100+',
    listImageFile: '5c92776a19563aaf83d68c6df404dbe0.png',
    detailImageZhFile: '264a4388fb28fb0ed2fc6e0b3ec0b68c.png',
    detailImageEnFile: 'e4eaf2fb786e445ad5d916b54b2396bb.png',
  },
  {
    merchantName: '和光',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.departmentStore,
    rating: '4.9',
    reviewCount: 68,
    participantCount: '600+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: 'af0b600a9c52175c2d7abe78ffe30619.png',
    detailImageEnFile: '0448c24708c443b96aad8a9e3c3fcdcb.png',
  },
  {
    merchantName: 'PARIS MIKI',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.optical,
    rating: '4.5',
    reviewCount: 45,
    participantCount: '400+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '6fff6bad3988307886a65e1956f4a389.png',
    detailImageEnFile: 'f79eda47963a183896d9d63fae63c318.png',
  },
  {
    merchantName: 'megane super',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.optical,
    rating: '4.6',
    reviewCount: 38,
    participantCount: '200+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '0b107d98907ac10d6a047c600a1a6a42.png',
    detailImageEnFile: 'f5cffd9ee767d41fe125f2bf0f0d2bd5.png',
  },
  {
    merchantName: 'HIROTAKA',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.jewelry,
    rating: '4.5',
    reviewCount: 26,
    participantCount: '100+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '6fff6bad3988307886a65e1956f4a389.png',
    detailImageEnFile: 'f79eda47963a183896d9d63fae63c318.png',
  },
  {
    merchantName: 'take-up',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.jewelry,
    rating: '4.6',
    reviewCount: 58,
    participantCount: '300+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '72fb99ecf0de16585d8cb18243c47645.png',
    detailImageEnFile: '40c4c68d6bce55b566d19c24ae3c5da3.png',
  },
  {
    merchantName: 'QOO VINTAGE',
    discount: localeText(
      '立减3000日元+免税劵',
      '立減3000日元+免稅劵',
      '3000 yen off + Tax-free',
      '3000 yen off + 免税劵',
      '3000 yen off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.vintage,
    rating: '4.5',
    reviewCount: 32,
    participantCount: '200+',
    listImageFile: COUPON_IMAGE_FILE_OVER,
    detailImageZhFile: 'ee26850859abef4a452f3a3f40d89edb.png',
    detailImageEnFile: 'ef609beef47667acd1a3dbc58e6dba78.png',
  },
  {
    merchantName: 'GINZA TAILOR',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.7',
    reviewCount: 16,
    participantCount: '100+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: 'f9e76b4253cd7bf47049a6f3da613b66.png',
    detailImageEnFile: '055f0bb5b6c5f0101e2a389de07b0401.png',
  },
  {
    merchantName: 'AMPLEUR',
    discount: localeText(
      '9折+免税劵',
      '9折+免稅劵',
      '10% Off + Tax-free',
      '10% Off + 免税劵',
      '10% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.beauty,
    rating: '4.5',
    reviewCount: 44,
    participantCount: '200+',
    listImageFile: COUPON_IMAGE_FILE_10,
    detailImageZhFile: 'cdce95fb1b0f654784f57865b13beaa3.png',
    detailImageEnFile: '4191bb4809c09762ee470fcb462ba41b.png',
  },
  {
    merchantName: '中川政七商店',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.other,
    rating: '4.4',
    reviewCount: 16,
    participantCount: '100+',
    listImageFile: '01716f92d9a21ca904a627f5fe5079e1.png',
    detailImageZhFile: '2aa6289d65ea5a4cb10dc5cda7d03cc4.png',
    detailImageEnFile: '75c4e2b2c3703e0559b6b6678ae13488.png',
  },
  {
    merchantName: 'Big Camera',
    discount: localeText(
      '93折+免税劵',
      '93折+免稅劵',
      '7% Off + Tax-free',
      '7% Off + 免税劵',
      '7% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.electronics,
    rating: '4.9',
    reviewCount: 121,
    participantCount: '500+',
    listImageFile: '1b13febcc41cba403065f230c1c00218.png',
    detailImageZhFile: '1d3d23feb8ddb068807184d1e2d14385.png',
    detailImageEnFile: 'e07a5459dd099a8228955eac66aea171.png',
  },
  {
    merchantName: 'ORIHICA',
    discount: localeText(
      '9折+免税劵',
      '9折+免稅劵',
      '10% Off + Tax-free',
      '10% Off + 免税劵',
      '10% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.fashion,
    rating: '4.7',
    reviewCount: 66,
    participantCount: '300+',
    listImageFile: COUPON_IMAGE_FILE_10,
    detailImageZhFile: '504523dbbddff33149bce26d88082b50.png',
    detailImageEnFile: 'fb6d8cb7d395790092e64be50f48fccc.png',
  },
  {
    merchantName: 'SIXTH NIGHT第六夜',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.jewelry,
    rating: '4.5',
    reviewCount: 56,
    participantCount: '200+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '8096a85a5bf2d1efdfb858be6233cd0d.png',
    detailImageEnFile: '54c92db12463140ae10bb5aa47d3948b.png',
  },
  {
    merchantName: '旅皿',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.homeGoods,
    rating: '4.8',
    reviewCount: 72,
    participantCount: '300+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '99268de052065985a6cf45616d83c8de.png',
    detailImageEnFile: 'e69d25753dc23868eeb9b7ae4c5117d1.png',
  },
  {
    merchantName: '堂吉柯德',
    discount: localeText(
      '93折+免税劵',
      '93折+免稅劵',
      '7% Off + Tax-free',
      '7% Off + 免税劵',
      '7% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.electronics,
    rating: '4.9',
    reviewCount: 131,
    participantCount: '600+',
    listImageFile: '26196276c02441ad77136eab282485fd.png',
    detailImageZhFile: '5b49a84ef6bff30f8d6d5109ad9bd2ce.png',
    detailImageEnFile: 'fc7e85124c59f0ca8b58084cf1bc93fd.png',
  },
  {
    merchantName: 'Cocokarafine',
    discount: localeText(
      '93折+免税劵',
      '93折+免稅劵',
      '7% Off + Tax-free',
      '7% Off + 免税劵',
      '7% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.drugstore,
    rating: '4.5',
    reviewCount: 45,
    participantCount: '100+',
    listImageFile: '873546f1abc658b7f4b3865522662a3f.png',
    detailImageZhFile: '4e5c935e7df212e44d22fb997244e42a.png',
    detailImageEnFile: '542d4f1a4b30bdbc66e2e7fed0810839.png',
  },
  {
    merchantName: '松本清',
    discount: localeText(
      '93折+免税劵',
      '93折+免稅劵',
      '7% Off + Tax-free',
      '7% Off + 免税劵',
      '7% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.drugstore,
    rating: '4.5',
    reviewCount: 25,
    participantCount: '200+',
    listImageFile: '187343304c71f3e8949d24b2a374ffcc.png',
    detailImageZhFile: '4e5c935e7df212e44d22fb997244e42a.png',
    detailImageEnFile: '542d4f1a4b30bdbc66e2e7fed0810839.png',
  },
  {
    merchantName: 'CocochiCosme',
    discount: localeText(
      '9折+免税劵',
      '9折+免稅劵',
      '10% Off + Tax-free',
      '10% Off + 免税劵',
      '10% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.beauty,
    rating: '4.7',
    reviewCount: 65,
    participantCount: '300+',
    listImageFile: COUPON_IMAGE_FILE_10,
    detailImageZhFile: '4d31a5633489ad5fb89667b5a90a2c8a.png',
    detailImageEnFile: '94cd529b9357934ddc26e82821345c15.png',
  },
  {
    merchantName: 'SJX',
    discount: localeText(
      '95折+免税劵',
      '95折+免稅劵',
      '5% Off + Tax-free',
      '5% Off + 免税劵',
      '5% Off + 면세劵',
    ),
    primaryCategory: COUPON_CATEGORY.shopping,
    secondaryCategory: COUPON_CATEGORY.jewelry,
    rating: '4.5',
    reviewCount: 31,
    participantCount: '200+',
    listImageFile: DEFAULT_COUPON_LIST_IMAGE_FILE,
    detailImageZhFile: '735d7928a3cc145d3d1f986ecdbbfb7f.png',
    detailImageEnFile: 'dc7da3d8ff342f5cac7e52c9bd3ddad1.png',
  },
])
